import angular from 'angular';
import CreateMessageComponent from './create-message-component';

export default angular.module('create-message', []).component('createMessage', new CreateMessageComponent());



// WEBPACK FOOTER //
// ./src/modules/message/components/create-message/create-message-module.js